// K85Board.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import K85BoardForm  from './K85BoardForm';
import EditK85Block from './EditK85Block';
import  ShowChangeK85Block  from './ShowChangeK85Block';
import { setData, getK85Props } from './actions';

import { tableschema1 } from './data/part1';
import { tableschema2 } from './data/part2';
import { tableschema3 } from './data/part3';
import { tableschema4 } from './data/part4';
import { tableschema5 } from './data/part5';
import { tableschema6 } from './data/part6';
import { tableschema7 } from './data/part7';

const tables = [
    tableschema1,
    tableschema2,
    tableschema3,
    tableschema4,
    tableschema5,
    tableschema6,
    tableschema7
];

const link_download = `/v1/k_85_file`;

const style_download = {
    display: 'flex',
    justifyContent: 'center'
};

const K85Board = ({ period, district, part, type, setCurDate }) => {
    const [boardData, setBoardData] = useState([]);
    const [dataType, setDataType] = useState('day');
    const [showEdit, setShowEdit] = useState(false);
    const [dataEdit, setDataEdit] = useState({});
    const [showChangeInfo, setShowChangeInfo] = useState(false);
    const [dataChangeInfo, setDataChangeInfo] = useState({});

    const setInfo = useCallback((data, part, type) => {
        setBoardData(data);
        setDataType(type);
    }, []);

    useEffect(() => {
        setData({ period, district, part, type }, setInfo);
    }, [period, district, part, type, setInfo]);

    const onCloseEdit = useCallback((updated) => {
        if(updated) setData({ period, district, part, type }, setInfo);
        setShowEdit(false);
        setDataEdit({});
    }, [period, district, part, type, setInfo]);

    const onOpenEdit = useCallback((data) => {
        if(dataType === 'day') {
            return alert(`Редагувати дані поточного періоду заборонено. Для редагування річного звіту оберіть період за грудень.`);
        }
        setShowEdit(true);
        setDataEdit(data);
    }, [dataType]);

    const onOpenChangeInfo = useCallback((data) => {
        setShowChangeInfo(true);
        setDataChangeInfo(data);
    }, []);

    const onCloseChangeInfo = useCallback(() => {
        setShowChangeInfo(false);
        setDataChangeInfo({});
    }, []);

    const { district: currentDistrict, period: currentPeriod, t, type: currentType } = getK85Props({ period, district, part, type });
    const file_url = `${link_download}?period=${currentPeriod}${(t && ('&type=' + t)) || ''}${'&district=' + currentDistrict}${'&part=all'}${'&mode=' + currentType}`;

    const DownloadButton = () => (
    <div className="k85-download-btn">
        <a href={file_url} target="_blank" rel="noopener noreferrer" download>
            <Button variant="primary">Завантажити у вигляді файлу</Button>
        </a>
    </div>
    );

    return (
        <div className="k85-statistics-board">
            <EditK85Block show={showEdit} data={dataEdit} close={onCloseEdit} />
            <ShowChangeK85Block show={showChangeInfo} data={dataChangeInfo} close={onCloseChangeInfo} />
            <K85BoardForm 
                schema={{ 
                    titles: tables[part].titles, 
                    parts: tables[part].parts, 
                    shorts: tables[part].shorts
                }} 
                data={boardData || []} 
                name={tables[part].name_table}
                openEdit={onOpenEdit}
                openChangeInfo={onOpenChangeInfo}
            />
            <DownloadButton />
        </div>
    );
};

export default K85Board;